<template>
  <div class="news-page__wrapper">
    <news-Item
      v-if="news"
      :id = "id"
      :public = "news.public"
      :title = "news.title"
      :content = "news.content"
      :image-src = "news.imageSrc"
      :format-html = "news.formatHtml"
    />
  </div>
</template>
<script>
import timeCombaine from '@/components/mixins/timeCombaine';
import appBaseNav from '@/components/mixins/appBaseNav';
import news from '@/components/mixins/api/apiMethodsNews';
import newsItem from '@/components/shared/upCard/NewsCard/NewsItem.vue';

export default {
  name: 'NewsPageView',
  props: {
    id: {
      type: [String, Number],
      requared: true,
    },
  },
  data() {
    return {
      news: null,
    };
  },
  mixins: [appBaseNav, news, newsItem, timeCombaine],
  components: { newsItem },
  mounted() {
    this.$store.commit('setPageTitle', this.$t('news.header_title'));
    this.getPage();
  },
  methods: {
    getPage() {
      this.isLoading = true;
      this.getNewsItem(this.id)
        .then((results) => {
          console.log(results);
          if (results) {
            this.news = {
              id: results.id,
              public: {
                date: `${this.dateEventShort(results.public_ts)}`,
                time: `${this.timeEvent(results.public_ts)}`,
              },
              title: results.title,
              content: results.content,
              imageSrc: results.preview,
              formatHtml: results.content_format !== 'text',
            };
          }
          this.isLoading = false;
        })
        .catch();
    },
  },
};
</script>
<style lang="scss">
.news-page {
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
    max-width: 760px;
    margin: 0 auto;
    padding: 12px;
  }
}
</style>
